module.exports = __webpack_public_path__ + "img/logo.e02eeb2d.png";